import { BcledgerComponent } from "./bcledger.component";
import { BacklogDetailsComponent } from "./components/backlog-details/backlog-details.component";
import { AdjustmentsComponent } from "./components/adjustments/adjustments.component";
import { ChargeBackComponent } from "./components/charge-back/charge-back.component";
import { FreightDetailsComponent } from "./components/freight-details/freight-details.component";

import { FreightComponent } from "./components/freight/freight.component";
import { GpAdjustmentComponent } from "./components/gp-adjustment/gp-adjustment.component";
import { MiscComponent } from "./components/misc/misc.component";
import { NetsChargedComponent } from "./components/nets-charged/nets-charged.component";
import { SalesCommissionComponent } from "./components/sales-commission/sales-commission.component";
import { SampleComponent } from "./components/sample/sample.component";
import { YTDGPComponent } from "./components/ytdgp/ytdgp.component";
import { CommissionsPaidTotalComponent } from "./components/commissions-paid-total/commissions-paid-total.component";
import { TotalSalesCommissionsAdjustmentsComponent } from "./components/total-sales-commissions-adjustments/total-sales-commissions-adjustments.component";
import { TotalApMiscComponent } from "./components/total-ap-misc/total-ap-misc.component";
import { Routes } from "@angular/router";

export const bcLedgerRoutes: Routes = [
  { path: "", component: BcledgerComponent },
  {
    path: "Misc/:BrandingConsultantID/:FromDate/:ToDate/:CategoryID",
    component: MiscComponent,
  },
  {
    path: "Samples/:BrandingConsultantID/:FromDate/:ToDate/:CategoryID",
    component: SampleComponent,
  },
  {
    path: "backlogdetails/:BrandingConsultantID/:FromDate/:ToDate/:CategoryID",
    component: BacklogDetailsComponent,
  },
  {
    path: "GPAdjustments/:BrandingConsultantID/:FromDate/:ToDate/:CategoryID",
    component: GpAdjustmentComponent,
  },
  {
    path: "Freight/:BrandingConsultantID/:FromDate/:ToDate/:CategoryID",
    component: FreightComponent,
  },
  {
    path: "freightdetail/:FreightTrackingNumber",
    component: FreightDetailsComponent,
  },
  {
    path: "SalesCommissions/:BrandingConsultantID/:FromDate/:ToDate/:CategoryID",
    component: SalesCommissionComponent,
  },
  {
    path: "Adjustments/:BrandingConsultantID/:FromDate/:ToDate/:CategoryID",
    component: AdjustmentsComponent,
  },
  {
    path: "NetsChargedorCredited/:BrandingConsultantID/:FromDate/:ToDate/:CategoryID",
    component: NetsChargedComponent,
  },
  {
    path: "Chargebacks/:BrandingConsultantID/:FromDate/:ToDate/:CategoryID",
    component: ChargeBackComponent,
  },
  {
    path: "YTDGP/:BrandingConsultantID/:FromDate/:ToDate/:CategoryID",
    component: YTDGPComponent,
  },
  {
    path: "CommissionsPaidTotal/:BrandingConsultantID/:FromDate/:ToDate/:CategoryID",
    component: CommissionsPaidTotalComponent,
  },
  {
    path: "TotalSalesCommissionsAdjustments/:BrandingConsultantID/:FromDate/:ToDate/:CategoryID",
    component: TotalSalesCommissionsAdjustmentsComponent,
  },
  {
    path: "TotalAPMisc/:BrandingConsultantID/:FromDate/:ToDate/:CategoryID",
    component: TotalApMiscComponent,
  },
];
